/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Select from 'react-select'
import Spinner from 'react-bootstrap/Spinner'
import { Table } from 'react-bootstrap-v5'
import { clampToShipmentDateBounds, getShipmentDateBounds, resolveInventoryBackdateDays, shipmentDateError, shipmentDateHint } from '../helpers/inventoryDateBounds'

interface ItemCreateProps {
	show: boolean;
	handleClose: any;
	salesOrderInfo: any;
	id: number;
}

interface OrderData {
	idSalesOrders: number;
	idProjects: number;
	idCompanies?: number;
	idWarehouses?: number;
	projectName: string;
	shippingAddress: string;
	shipmentDate: string;
	inventoryBackdateDays?: number;
	chalanNo: string;
	vehicleNo: string;
	driverName: string;
	driverPhoneNo: string;
	receiverName: string;
	receiverPhoneNo: string;
	remarks: string;
}

interface OrderRows {
	idProducts: number;
	quantity: number;
	rate: number;
	discount: number;
	originalAmount: number;
	amount: number;
	originalRate: number;
	[key: string]: any; // Index signature
}

// interface FreeRows {
// 	idProducts: number;
// 	quantity: number;
// 	[key: string]: any; // Index signature
// }

// interface ProjectAmount {
// 	invoice: number;
// 	payment: number;
// 	shipment: number;
// }

const initialOrderData: OrderData = {
	idSalesOrders: 0,
	idProjects: 0,
	idCompanies: 0,
	idWarehouses: 0,
	projectName: '',
	shippingAddress: '',
	shipmentDate: '',
	chalanNo: '',
	vehicleNo: '',
	driverName: '',
	driverPhoneNo: '',
	receiverName: '',
	receiverPhoneNo: '',
	remarks: '',
}

const ShipmentCreate: React.FC<ItemCreateProps> = ({ show, handleClose, salesOrderInfo, id }) => {

	const [projects, setProjects] = useState([]);
	const [project, setProject] = useState({ label: 'Select Project', value: '' });
	const [salesOrders, setSalesOrders] = useState([]);
	const [salesOrder, setSalesOrder] = useState({ label: 'Select Sales Order', value: '' });
	const [orderData, setOrderData] = useState<OrderData>(initialOrderData);
	const [orderRows, setOrderRows] = useState<OrderRows[]>([]);
	const [freeRows, setOrderFreeRows] = useState<OrderRows[]>([]);

	// Warehouse dropdown state
	const [warehouses, setWarehouses] = useState([]);
	const [warehouse, setWarehouse] = useState({ label: 'Select Warehouse', value: '' });
	const [shippingAddressOptions, setShippingAddressOptions] = useState<any[]>([]);
	const [selectedShippingAddress, setSelectedShippingAddress] = useState<any>(null);


	useEffect(() => {
		getProjects()
		setOrderData(initialOrderData)
		setOrderRows([])
		setSalesOrder({ label: 'Select Sales Order', value: '' })
		setShippingAddressOptions([])
		setSelectedShippingAddress(null)
		if (salesOrderInfo && salesOrderInfo.idSalesOrders !== undefined) {
			getSalesOrderRows(salesOrderInfo.idSalesOrders);
		}

	}, [salesOrderInfo, id]);

	const buildShippingAddressOptions = (addresses: any[] = [], fallbackAddress: string = '') => {
		const list = (addresses || [])
			.filter((item: any) => (item?.address || '').toString().trim() !== '')
			.map((item: any, index: number) => {
				const addressText = (item.address || '').toString().trim();
				const name = (item.name || '').toString().trim() || `Address ${index + 1}`;
				const isDefault = item.isDefault === 'Yes' || item.is_default === 'Yes';
				const displayName = isDefault && name.toLowerCase() !== 'default'
					? `${name} (Default)`
					: name;
				return {
					value: String(item.id ?? `fallback-${index}`),
					label: `${displayName} — ${addressText}`,
					address: addressText,
					name,
					isDefault,
				};
			});

		if (!list.length && fallbackAddress) {
			list.push({
				value: 'company-address',
				label: `Default — ${fallbackAddress}`,
				address: fallbackAddress,
				name: 'Default',
				isDefault: true,
			});
		}

		return list;
	};

	const applyShippingAddresses = (addresses: any[] = [], fallbackAddress: string = '', orderShippingAddress: string = '') => {
		const options = buildShippingAddressOptions(addresses, fallbackAddress);
		setShippingAddressOptions(options);

		const orderAddr = (orderShippingAddress || '').toString().trim();
		const matchedOption = options.find((item: any) => item.address === orderAddr)
			|| (orderAddr ? null : (options.find((item: any) => item.isDefault) || options[0] || null));
		setSelectedShippingAddress(matchedOption);

		// Keep order shipping address; only fill from default/options if empty
		if (!orderAddr) {
			const addressText = (matchedOption?.address || fallbackAddress || '').toString().trim();
			if (addressText) {
				setOrderData((prev) => ({
					...prev,
					shippingAddress: addressText,
				}));
			}
		}
	};

	const loadCompanyShippingAddresses = (idCompanies: number, orderShippingAddress: string = '') => {
		if (!idCompanies) {
			setShippingAddressOptions([]);
			setSelectedShippingAddress(null);
			return;
		}

		fetch(
			process.env.REACT_APP_API_URL + 'company-credit-info/' + idCompanies,
			getRequestOptions()
		)
			.then((resp) => resp.json())
			.then((resp) => {
				applyShippingAddresses(resp.data?.addresses || [], resp.data?.address || '', orderShippingAddress);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
				setShippingAddressOptions([]);
				setSelectedShippingAddress(null);
			});
	};

	const getSalesOrderRows = (idSalesOrders: number) => {
		fetch(
			process.env.REACT_APP_API_URL + 'sales-order-rows/' + idSalesOrders,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let orderRows = resp.data.map((item: any) => {
					return item
				})
				let freeRows = resp.freeRows.map((item: any) => {
					return item
				})
				setOrderRows(orderRows);
				setOrderFreeRows(freeRows);
				setOrderData(resp.salesorder);
				getWarehousesByProject(resp.salesorder.idProjects);
				loadCompanyShippingAddresses(resp.salesorder.idCompanies, resp.salesorder.shippingAddress || '');
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	};

	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);

	const backdateDays = resolveInventoryBackdateDays(project?.value ? project : orderData);
	const dateBounds = getShipmentDateBounds(backdateDays);

	const handleChange = (e: any) => {
		const { name, value } = e.target;
		setOrderData({
			...orderData,
			[name]: name === 'shipmentDate' ? clampToShipmentDateBounds(value, backdateDays) : value,
		});

		if (name === 'shippingAddress') {
			const matchedOption = shippingAddressOptions.find((item: any) => item.address === value) || null;
			setSelectedShippingAddress(matchedOption);
		}
	};

	const handleShippingAddressChange = (selectedOption: any) => {
		setSelectedShippingAddress(selectedOption);
		if (selectedOption?.address) {
			setOrderData((prev) => ({
				...prev,
				shippingAddress: selectedOption.address,
			}));
		}
	};


	// Fetch warehouses by project
	const getWarehousesByProject = (idProjects: number) => {
		if (!idProjects) {
			setWarehouses([]);
			setWarehouse({ label: 'Select Warehouse', value: '' });
			return;
		}
		fetch(
			process.env.REACT_APP_API_URL + 'warehouse/' + idProjects + '/list',
			getRequestOptions()
		)
			.then((resp) => resp.json())
			.then((resp) => {
				if (resp.success && Array.isArray(resp.data)) {
					const whOptions = resp.data.map((item: any) => ({
						label: item.name,
						value: item.id_warehouses
					}));
					setWarehouses(whOptions);
				} else {
					setWarehouses([]);
				}
				setWarehouse({ label: 'Select Warehouse', value: '' });
			})
			.catch(() => {
				setWarehouses([]);
				setWarehouse({ label: 'Select Warehouse', value: '' });
			});
	};

	const handleWarehouseChange = (selected: any) => {
		setWarehouse(selected);
		setOrderData({ ...orderData, idWarehouses: selected ? selected.value : '' });
	};

	const handleOrderDataChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
		const updatedOrderRows = [...orderRows];

		let remainingQuantity = updatedOrderRows[index].quantity - updatedOrderRows[index].already_delivered

		if (remainingQuantity < parseFloat(e.target.value)) {
			Swal.fire({
				icon: 'error',
				title: 'Warning',
				text: 'Quantity exceeds',
			})
			updatedOrderRows[index][e.target.name] = 0;
			setOrderRows(updatedOrderRows);
			e.target.value = '';
			return true
		}
		updatedOrderRows[index][e.target.name] = e.target.value;
		setOrderRows(updatedOrderRows);
	}

	const handleFreeOrderDataChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
		const updatedFreeRows = [...freeRows];

		let remainingQuantity = updatedFreeRows[index].quantity - updatedFreeRows[index].already_delivered

		if (remainingQuantity < parseFloat(e.target.value)) {
			Swal.fire({
				icon: 'error',
				title: 'Warning',
				text: 'Quantity exceeds',
			})
			updatedFreeRows[index][e.target.name] = 0;
			setOrderFreeRows(updatedFreeRows);
			e.target.value = '';
			return true
		}
		updatedFreeRows[index][e.target.name] = e.target.value;
		setOrderFreeRows(updatedFreeRows);
	}

	const handleProjectChange = (project: any) => {
		setProject(project);
		getOrdersByProjects(project.value);
		setOrderData({
			...orderData,
			idProjects: project.id || project.value,
			inventoryBackdateDays: resolveInventoryBackdateDays(project),
			shipmentDate: clampToShipmentDateBounds(orderData.shipmentDate, resolveInventoryBackdateDays(project)),
		});

		getWarehousesByProject(project.value);
        setWarehouse({ label: 'Select Warehouse', value: '' });
	}

	const getOrdersByProjects = (idProjects: number) => {

		fetch(
			process.env.REACT_APP_API_URL + 'shipment-sales-order-by-project/' + idProjects,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let orderObj = resp.data.map((item: any) => {
					item.label = 'Order # ' + item.id + ', Date: ' + item.sales_order_date + ', Client: ' + item.company_name + ', Amount: ' + item.order_amount;
					item.value = item.id;
					return item
				})
				setSalesOrders(orderObj);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getProjects = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'lead/projects',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let projects = resp.data.map((item: any) => {
					item.label = item.name;
					item.value = item.id;
					return item
				})
				setProjects(projects);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const shipmentSave = async (event: any) => {
		event.preventDefault()
		const dateError = shipmentDateError(orderData.shipmentDate, backdateDays);
		if (dateError) {
			Swal.fire({ icon: 'error', title: 'Error', text: dateError });
			return;
		}
		setLoading(true);
		setSubmitDisable(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		})
		if (confirm.value) {

			const postData = {
				shipment: orderData,
				shipmentRows: orderRows,
				freeRows: freeRows
			}
			const requestOptions = postRequestOptions(postData)
			try {
				let response = await fetch(
					`${process.env.REACT_APP_API_URL}shipment`,
					requestOptions
				)
				let respData = await response.json()
				if (respData.success === true) {
					const successMsg = respData.successMessage
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					})
					handleClose(respData.success)
					// history.push('/shipments')
				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
				setSubmitDisable(false);
				setLoading(false);


			} catch (error) {
				setLoading(false);
				console.log(error, 'catch the hoop')
				setSubmitDisable(false);
			}
		} else {
			setSubmitDisable(false);
			setLoading(false);
		}
	}

	const handleSalesOrderChange = (salesOrder: any) => {

		setSalesOrder(salesOrder);
		setShippingAddressOptions([]);
		setSelectedShippingAddress(null);
		setOrderData({ ...orderData, idSalesOrders: salesOrder.value, shippingAddress: '' });
		getSalesOrderRows(salesOrder.value);
		
	}


	return (
		<Modal show={show} onHide={() => handleClose(false)} size="xl">
			<form onSubmit={shipmentSave}>
				<Modal.Header closeButton>
					{orderData.idSalesOrders !== 0 &&
						<Modal.Title>Order Shipment (Order No # {orderData.idSalesOrders})</Modal.Title>
					}
					{orderData.idSalesOrders === 0 &&
						<Modal.Title>Create New Shipment</Modal.Title>
					}
				</Modal.Header>
				<Modal.Body>
					{/* {JSON.stringify(orderData, null, 2)} */}
					{orderData.idProjects !== null &&
						<div className="form-group row">
							<label htmlFor="companyName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Project <span className="required text-danger"></span></label>
							<div className="col-lg-5">


								{salesOrderInfo === null &&
									<Select
										value={project}
										onChange={handleProjectChange}
										options={projects}
										menuPosition="fixed"
									/>
								}
								{salesOrderInfo !== null &&
									<div>{orderData.projectName}</div>
								}
							</div>
						</div>
					}
					{/* {orderData.idProjects !== 0 && orderData.idProjects !== null &&
						<div className="form-group row">
							<label htmlFor="companyName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}></label>
							<div className="col-lg-5">Total Shipment Amount : {projectAmount.shipment}; Total Invoice Amount : {projectAmount.invoice}; Total Payment Made: {projectAmount.payment}</div>
						</div>
					} */}

					<div className="form-group row">
						<label htmlFor="idWarehouses" className="col-lg-3 col-form-label" style={{ textAlign: "right" }}>Select Warehouse <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<Select
								value={warehouse}
								onChange={handleWarehouseChange}
								options={warehouses}
								menuPosition="fixed"
								styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
								isDisabled={warehouses.length === 0}
							/>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="idCompanyProjects" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Sales Order <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							{salesOrderInfo === null &&
								<Select
									value={salesOrder}
									onChange={handleSalesOrderChange}
									options={salesOrders}
									menuPosition="fixed"
								/>
							}
							{salesOrderInfo !== null &&
								<div>Order # {orderData.idSalesOrders}</div>
							}
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="shipmentDate" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Shipment Date <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<input
								type="date"
								name="shipmentDate"
								id="shipmentDate"
								value={orderData.shipmentDate}
								min={dateBounds.minDate || undefined}
								max={dateBounds.maxDate}
								onChange={handleChange}
								className="form-control form-control-sm"
								disabled={!orderData.idProjects}
								required
							/>
							<div className="form-text text-muted mt-1">
								{shipmentDateHint(!!orderData.idProjects, backdateDays)}
							</div>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="shippingAddress" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Shipping Address <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<Select
								value={selectedShippingAddress}
								onChange={handleShippingAddressChange}
								options={shippingAddressOptions}
								placeholder={orderData.idCompanies ? 'Quick pick from client addresses' : 'Select Sales Order first'}
								isDisabled={!orderData.idCompanies || shippingAddressOptions.length === 0}
								isClearable={true}
								menuPosition="fixed"
								styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
								className="mb-2"
							/>
							<input
								type="text"
								name="shippingAddress"
								id="shippingAddress"
								value={orderData.shippingAddress}
								onChange={handleChange}
								className="form-control form-control-sm"
								placeholder="Shipping address (editable)"
								required
							/>
							<div className="form-text text-muted mt-1">
								Quick pick fills the box below. You can edit or type any custom address.
							</div>
						</div>
					</div>
					{/* <div className="form-group row">
						<label htmlFor="chalanNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Chalan No</label>
						<div className="col-lg-5">
							<input type="text" name="chalanNo" id="chalanNo" value={orderData.chalanNo} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div> */}
					<div className="form-group row">
						<label htmlFor="vehicleNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Vehicle No </label>
						<div className="col-lg-5">
							<input type="text" name="vehicleNo" id="vehicleNo" value={orderData.vehicleNo} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="driverName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Driver Name </label>
						<div className="col-lg-5">
							<input type="text" name="driverName" id="driverName" value={orderData.driverName} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="driverPhoneNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Driver Phone No </label>
						<div className="col-lg-5">
							<input type="text" name="driverPhoneNo" id="driverPhoneNo" value={orderData.driverPhoneNo} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="receiverName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Receiver Name </label>
						<div className="col-lg-5">
							<input type="text" name="receiverName" id="receiverName" value={orderData.receiverName} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="receiverPhoneNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Receiver Phone No </label>
						<div className="col-lg-5">
							<input type="text" name="receiverPhoneNo" id="receiverPhoneNo" value={orderData.receiverPhoneNo} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="remarks" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Remarks</label>
						<div className="col-lg-5">
							<textarea name="remarks" id="remarks" rows={5} value={orderData.remarks} onChange={handleChange} className="form-control form-control-sm"></textarea>
						</div>
					</div>

					<br></br>
					<Table size='sm' bordered hover>
						<thead>
							<tr>
								<th style={{ width: '5%' }} className='text-center'>SL</th>
								<th style={{ width: '25%' }}>Product Name</th>
								<th style={{ width: '10%' }}>Packing</th>
								<th style={{ width: '10%' }}>Unit</th>
								<th style={{ width: '15%' }}>Order Quantity</th>
								<th style={{ width: '10%' }}>Already Delivered</th>
								<th style={{ width: '15%' }}>Deliver Quantity</th>
							</tr>
						</thead>


						<tbody>

							{orderRows.map((row, index) => (
								<tr key={index}>
									<td className='text-center'>{index + 1}</td>
									<td>{row.product_name}</td>
									<td>{row.packing + ' ' + row.item_unit_name}</td>
									<td>{row.product_unit_name}</td>
									<td>{row.quantity}</td>
									<td>{row.already_delivered}</td>
									<td>
										<input type="number" name="shipment_quantity" onChange={(event) => handleOrderDataChange(event, index)} className="form-control form-control-sm" />
									</td>
								</tr>
							))}
						</tbody>
					</Table>
					
					{freeRows.length !== 0 &&
						<>
							<br></br>
							<h3>Free Items</h3>
							<Table size='sm' bordered hover>
								<thead>
									<tr>
										<th style={{ width: '5%' }} className='text-center'>SL</th>
										<th style={{ width: '35%' }}>Product Name</th>
										<th style={{ width: '10%' }}>Packing</th>
										<th style={{ width: '10%' }}>Unit</th>
										<th style={{ width: '15%' }}>Order Quantity</th>
										<th style={{ width: '10%' }}>Already Delivered</th>
										<th style={{ width: '15%' }}>Deliver Quantity</th>
									</tr>
								</thead>
								<tbody>
									{freeRows.map((row, index) => (
										<tr key={index}>
											<td className='text-center'>{index + 1}</td>
											<td>{row.product_name}</td>
											<td>{row.packing + ' ' + row.item_unit_name}</td>
											<td>{row.product_unit_name}</td>
											<td>{row.quantity}</td>
											<td>{row.already_delivered}</td>
											<td>
												<input type="number" name="shipment_quantity" onChange={(event) => handleFreeOrderDataChange(event, index)} className="form-control form-control-sm" />
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</>
					}


					{/* <pre>{JSON.stringify(orderRows, null, 2)}</pre> */}
				</Modal.Body>
				<Modal.Footer>

					<button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
						{loading &&
							<Spinner
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						}
						<span>  Submit</span>
					</button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default ShipmentCreate
